module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_1.792f54b8.png";